(ns manage.export-tags-ocp.view
  (:require ["@mui/material/Button$default" :as Button]
            ["@mui/material/Divider$default" :as Divider]
            ["@mui/material/Icon$default" :as Icon]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/Tooltip$default" :as Tooltip]
            [common.flags :refer [use-flag]]
            [common.ocp.view :refer [defocp ocp]]
            [common.widgets.checkbox :refer [checkbox]]
            [common.widgets.form-field :refer [form-field]]
            [manage.export-tags-ocp.db :as form]
            [re-frame.core :as rf]
            [uix.core :as uix :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(def ^:private all-dsps
  [{:id "generic"
    :label "Generic"}
   {:id "DV360"
    :label "DV360"}
   {:id "Adform"
    :label "Adform"}
   {:id "Xandr"
    :label "Xandr"}
   {:id "Quantcast"
    :label "Quantcast"}
   {:id "TTD"
    :label "The TradeDesk"}
   {:id "Amazon"
    :label "Amazon"}])

(defn filter-dsps
  [xandr-enabled?]
  (cond->> all-dsps
    (not xandr-enabled?) (remove #(= "Xandr" (:id %)))))

(def ^:private additional-settings
  [{:id :gdpr
    :label ($ Stack {:direction "row" :gap 1 :alignItems "center"}
              "GDPR"
              ($ Tooltip {:placement :top
                          :title "Due to regulations it is mandatory to include this in your tag if you want to run your ads in Europe"}
                 ($ Icon {:fontSize "small"} "help_outline")))}
   {:id :click-tag
    :label "Clicktag"}])

(defui binded-checkbox [{:keys [id label store-keyword]}]
  ($ checkbox
     (assoc (form/use-bind-control [store-keyword id])
            :id (name id)
            :label label)))

(defui checkboxes [{:keys [items store-keyword]}]
  ($ Stack
     (for [{:keys [id label]} items]
       ($ binded-checkbox {:key id :id id :label label :store-keyword store-keyword}))))

(defui ocp-footer []
  (let [has-errors (use-subscribe [:form.export-tags-configuration/errors?])]
    ($ Button
       {:type :submit
        :variant "contained"
        :disabled has-errors}
       "Generate")))

(defocp export-tags-configuration-ocp :export-tags-configuration-ocp
  [{:keys [export-target adset-ids]}]
  (let [xandr-enabled? (use-flag :xandr-adserver-support)
        dsps (filter-dsps xandr-enabled?)]
    (uix/use-effect (fn []
                      (rf/dispatch [:form.export-tags-configuration/init])
                      (rf/dispatch [:form.export-tags-configuration/show-all-errors])
                      (fn []
                        (rf/dispatch [:form.export-tags-configuration/destroy])))
                    [])
    ($ ocp
       {:title "Generate tags"
        :on-submit #(rf/dispatch [:form.export-tags-configuration/submit export-target adset-ids])
        :footer ($ ocp-footer)}
       ($ form-field
          {:label "Please select your DSP types"
           :err-msg (form/use-error-message [:dsp-ids])
           :data-testid :export-tags-configuration--dsp-ids}
          ($ checkboxes {:items dsps :store-keyword :dsp-ids}))
       ($ Divider)
       ($ form-field
          {:label "Please select your additional settings"
           :err-msg (form/use-error-message [:additional-settings])
           :data-testid :export-tags-configuration--additional-settings}
          ($ checkboxes {:items additional-settings :store-keyword :additional-settings})))))
